const DAYS_IN_MONTH = 30;

export function getLastMonthDates(): { startDate: string; endDate: string } {
  const today = new Date();
  const endDate = today.toISOString().slice(0, 10);

  const start = new Date(today);
  start.setDate(today.getDate() - (DAYS_IN_MONTH - 1));
  const startDate = start.toISOString().slice(0, 10);

  return { startDate, endDate };
}

export function endOfDay(date: string | Date): Date {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
}

/** Returns true when the given date is strictly before today (date-only, ignores time). */
export function isPastDate(value: string | Date | null | undefined): boolean {
  if (!value) {
    return false;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const date = new Date(value);
  date.setHours(0, 0, 0, 0);

  return date < today;
}
